import { createSelector } from 'reselect';

export const presetsSelector = (state: any): any[] | null => state.presets.items;
export const selectedPresetIdSelector = (state: any): any => state.presets.selectedItemId;
export const selectedPresetIdForRemoval = (state: any): any => state.presets.itemIdThatGoingToBeRemoved;

export const selectedPresetSelector = createSelector(presetsSelector, selectedPresetIdSelector, (items, selectedId) => {
    if (!items) {
        return null;
    }

    const item = items.find((i: any) => i.id === selectedId);

    return item && item.elements ? item : null;
});

export const selectedPresetElementSelector = createSelector(selectedPresetSelector, (preset: any) => ({
    ...(Object.values(preset.elements)[0] as any),
    presetId: preset.id,
    name: preset.name,
}));
